/** 미용·헬스 포트폴리오 스크린샷 — public/portfolio/beauty-health/ */

function beautyHealthSrc(filename) {
  return `/portfolio/beauty-health/${encodeURIComponent(filename)}`;
}

function beautyHealthItem(id, title, filename, url) {
  return { id, title, url, src: beautyHealthSrc(filename) };
}

export const BEAUTY_HEALTH_PORTFOLIO_IMAGES = [
  beautyHealthItem("bella", "BELLA", "1.webp", "bella.dsite"),
  beautyHealthItem("man-code", "MAN CODE", "2.webp", "mancode.dsite"),
  beautyHealthItem("blanchee", "Blanchee", "3.webp", "blanchee.dsite"),
  beautyHealthItem("muscle-factory", "MUSCLE FACTORY", "4.webp", "muscle-factory.dsite"),
  beautyHealthItem("stronger", "STRONGER", "5.webp", "stronger-fitness.dsite"),
];

export const DEFAULT_BEAUTY_HEALTH_IMAGE = BEAUTY_HEALTH_PORTFOLIO_IMAGES[0];
